import React, { useEffect, useState } from 'react'
import UserModel from './models/UserModel';

function DeleteUser(props) {
  const [getDeleteUser, setDeleteUser] = useState(new UserModel() || []);

  useEffect(() => {
    setDeleteUser(props.UserData);
  }, [props.UserData])
  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following User will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Full Name :</b> {getDeleteUser.FullName}</li>
            <li><b>Email : </b>{getDeleteUser.Email}</li>
            <li><b>User Name </b>:{getDeleteUser.UserName}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteUserDetails" hidden>{JSON.stringify(getDeleteUser)}</div>
    </>
  )
}

export default DeleteUser